// About page entry point — composes the page from independent feature modules.
// All animation/motion lives in ./motion.js (one file per page).

import { initSwiperAboutWithResize } from './swiper-about.js';
import { initAboutMotion } from './motion';

// ─── Swipers ──────────────────────────────────────────────────────────────────
initSwiperAboutWithResize();

// ─── All page motion: section reveals ────────────────────────────────────────
initAboutMotion();
